import { CRUDService } from './crud-service.class'

export class BalansZ2Service extends CRUDService {
  subject = 'balance_z2'
}
